import * as Yup from 'yup';

export default Yup.object().shape({
  rate: Yup.number()
    .typeError('SCHEMA_ERRORS.RATE_MUST_BE_A_NUMBER')
    .positive('SCHEMA_ERRORS.NUMBER_MUST_BE_GREATER_THAN_ZERO')
    .max(100, 'SCHEMA_ERRORS.NUMBER_MUST_BE_LESS_THAN_ONE_HUNDRED')
    .required('SCHEMA_ERRORS.RATE_REQUIRED')
    .nullable()
});
